var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9621 5.64249V2.85249C11.9621 2.40249 11.4221 2.18249 11.1121 2.50249L7.31209 6.29249C7.11209 6.49249 7.11209 6.80249 7.31209 7.00249L11.1021 10.7925C11.4221 11.1025 11.9621 10.8825 11.9621 10.4325V7.64249C15.6921 7.64249 18.6421 11.0625 17.8221 14.9325C17.3521 17.2025 15.5121 19.0325 13.2521 19.5025C9.68209 20.2525 6.50209 17.8025 6.02209 14.4925C5.95209 14.0125 5.53209 13.6425 5.04209 13.6425C4.44209 13.6425 3.96209 14.1725 4.04209 14.7725C4.66209 19.1625 8.84209 22.4125 13.5721 21.4925C16.6921 20.8825 19.2021 18.3725 19.8121 15.2525C20.8021 10.1225 16.9021 5.64249 11.9621 5.64249Z",
    fill: "#8E8D8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.58852f0f69647bf366e601dd1de773fb.svg";
export { ForwardRef as ReactComponent };